export enum RoleEnum {
  Administrator = "Administrator",
  Annotator = "Annotator"
}
